<template>
  <div class="intro-container">
    <h1 class="intro-title">{{ yearTitle }}</h1>
    <p class="intro-description">
      {{ year }}년 운세 서비스는
      당신 사주의 
      <strong>십신</strong>과 <strong>격국</strong>을 파악하고
      {{ year }}년에 드는 전간과 지지가 당신의 사주와 맺는
      관계를 고려하여 한해의 세운(歲運)을 간략히 풀어줍니다. ({{ LYD }}LYD 필요)
    </p>

    <div class="intro-actions">
      <label class="checkbox">
        <input type="checkbox" v-model="skipNext" />
        다시 보지 않기
      </label>
      <div class="buttons">
        <button @click="proceed">이용하기</button>
        <button @click="cancel">돌아가기</button>
      </div>
    </div>
  </div>
</template>

<script setup>
  import { ref, onMounted } from 'vue'
  import { useRouter } from 'vue-router'
  import { getGanjiByYear } from '@/utils/utils'

  const LYD = ref(import.meta.env.VITE_CHARGE_FORTUNE)
  const router = useRouter()
  const skipNext = ref(false)
  const storageKey = 'skipIntroFortune'
  const proceedTo = '/SetupSajuData?from=IntroFortune'

  const yearTitle = ref('')
  const year = ref('')
  const now = new Date()
  const thisYear = now.getFullYear()
  const month = now.getMonth() + 1

  // 11~12월은 미리 내년 운세를 보여줌
  const targetYear = month >= 11 ? thisYear + 1 : thisYear
  year.value = targetYear

  const ganji = getGanjiByYear(targetYear)

  yearTitle.value = `${targetYear} ${ganji}년 운세`

  function proceed() {
    if (skipNext.value) {
      localStorage.setItem(storageKey, 'true')
    }
    router.replace(proceedTo)
  }

  function cancel() {
    router.go(-1)
  }

  onMounted(() => {
    if (localStorage.getItem(storageKey) === 'true') {
      router.replace(proceedTo)
    }
  })
</script>

<style scoped>
  .intro-container {
    min-height: 100vh;
    width: var(--device-width);
    max-width: 480px;
    margin: auto;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    padding: 1.2rem;
    box-sizing: border-box;
    text-align: center;
  }

  .intro-title {
    font-size: var(--font-size-16);
    font-weight: bold;
    margin-bottom: 1.5rem;
  }

  .intro-description {
    font-size: var(--font-size-11);
    line-height: 1.6;
    margin-bottom: 2rem;
    width: 90%;
  }
  .intro-actions {
    display: flex;
    flex-direction: column;
    align-items: center;
    gap: 1rem;
  }

  .checkbox {
    font-size: var(--font-size-09);
  }

  .buttons {
    display: flex;
    gap: 1.2rem;
  }

  button {
    padding: 0.7rem 1.5rem;
    font-size: var(--font-size-10);
    border: none;
    border-radius: 8px;
    background-color: #333;
    color: white;
    cursor: pointer;
  }

  button:first-child {
    background-color: #4caf50; /* Green */
    color: white;
  }

  button:first-child:hover {
    background-color: #45a049;
  }

  button:last-child {
    background-color: #f44336; /* Red */
    color: white;
  }

  button:last-child:hover {
    background-color: #da190b;
  }
</style>
